/* eslint-disable */

export default ({module}) => ({
    //
})